import { takeEvery, put, fork } from "redux-saga/effects";
import * as actions from "../actions/EquipmentAction";
import * as api from "../../api/EquipmentApi";
import moment from "moment";
import { setBackdrop, resetBackdrop } from "../actions/BackdropActions";
import { showSuccessSnackbar, showErrorSnackbar } from "../actions/SnackbarActions";
import { getFilesFromZip } from "../../common";

function* getEqGetMainListByAreaID(action) {
    try {
        const { data } = yield api.getEqGetMainListByAreaID(action.payload);
        yield put(actions.setEqGetMainListByAreaID(data || undefined));
    } catch (error) {
        yield put(actions.setEqGetMainListByAreaID(undefined));
        yield put(actions.eqGetMainListByAreaIDFailure(error));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}
function* getEqGetSubListById(action) {
    try {
        const { data } = yield api.getEqGetSubListById(action.payload);
        console.log(data);
        yield put(actions.setEqGetSubListById(data || undefined));
    } catch (error) {
        yield put(actions.setEqGetSubListById(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getEqGetByBarcodeContext(action) {
    try {
        const { data } = yield api.getEqGetByBarcodeContext(action.payload);
        console.log(data);
        yield put(actions.setEqGetByBarcodeContext(data || undefined));
    } catch (error) {
        yield put(actions.setEqGetByBarcodeContext(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getEqDetailList(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getEqDetailList(action.payload);
        yield put(actions.setEqDetailList(data || undefined));
    } catch (error) {
        yield put(actions.getEqDetailList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* deleteEquipment(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.deleteEquipment(action.payload);
        yield put(actions.deleteEquipmentRes(data || undefined));
        yield put(actions.resetDelEq());
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(actions.deleteEquipmentRes(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getEquipmentDetailById(action) {
    console.log("action:", action);
    try {
        const { data } = yield api.getEquipmentDetailById(action.payload);
        yield put(actions.setEquipmentDetailById(data || undefined));
        if (!action.payload.editEqRequest) {
            yield put(actions.getEquipmentReportList());
        }
        if (action.payload.eqGroup) {
            yield put(actions.getEquipmentReportList());
        }
    } catch (error) {
        yield put(actions.setEquipmentDetailById(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getEquipmentReportGroupById(action) {
    try {
        const { data } = yield api.getEquipmentReportGroupById(action.payload);
        yield put(actions.setEquipmentReportGroupById(data || undefined));
        // yield put(actions.resetEqGroup());
    } catch (error) {
        yield put(actions.setEquipmentReportGroupById(undefined));
    }
    yield put(setBackdrop());
}

function* getEquipmentReportGroupList() {
    try {
        const { data } = yield api.getEquipmentReportGroupList();
        yield put(actions.setEquipmentReportList(data || undefined));
    } catch (error) {
        yield put(actions.setEquipmentReportList(undefined));
    }
    yield put(setBackdrop());
}

function* editEquipmentGroupInfo(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.editEquipmentGroupInfo(action.payload);
        yield put(actions.setEditEquipmentGroupInfo(data || undefined));
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(actions.setEditEquipmentGroupInfo(error));
    }
    yield put(setBackdrop());
}

function* getAreaList() {
    try {
        const { data } = yield api.getAreaList();
        console.log({ data });
        yield put(actions.setAreaList(data || undefined));
    } catch (error) {
        yield put(actions.setAreaList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}
function* getCostCenterList() {
    try {
        const { data } = yield api.getCostCenterList();
        console.log({ data });
        yield put(actions.setCostCenterList(data));
    } catch (error) {
        yield put(actions.setCostCenterList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}
function* getPlantList() {
    try {
        const { data } = yield api.getPlantList();
        yield put(actions.setPlantList(data || undefined));
    } catch (error) {
        yield put(actions.setPlantList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}
function* getEquipmentTypeList() {
    try {
        const { data } = yield api.getEquipmentTypeList();
        yield put(actions.setEquipmentTypeList(data || undefined));
    } catch (error) {
        yield put(actions.setEquipmentTypeList(error));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}
function* getEqMainList(action) {
    try {
        const { data } = yield api.getEqMainList(action.payload);
        yield put(actions.setEqMainList(data || undefined));
        yield put(actions.resetEqMainList());
    } catch (error) {
        yield put(actions.setEqMainList(error));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getEditEquipment(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.getEditEquipment(action.payload);
        yield put(actions.setEditEquipment(data || undefined));
        yield put(actions.resetEqRes());
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}
function* getAddEquipment(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.getAddEquipment(action.payload);
        yield put(actions.setAddEquipment(data || undefined));
        yield put(actions.resetEqRes());
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* downloadExcelFile() {
    try {
        const { data } = yield api.downloadExcel();
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        const filename = "MOST_EquipmentList_" + moment(new Date()).format("DD_MM_YYYY_HH_mm_ss") + ".xlsx"; //name with date time & extension
        link.setAttribute("download", filename); //or any other extension
        document.body.appendChild(link);
        link.click();
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
}

function* getEquipmentFiles(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getEquipmentFiles(action.payload);
        const files = yield getFilesFromZip(data);
        yield put(actions.setEquipmentFiles(files || undefined));
    } catch (error) {
        yield put(actions.setEquipmentFiles(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* addEquipmentFiles(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.addEquipmentFiles(action.payload);
        yield put(showSuccessSnackbar(data.message));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* deleteEquipmentFiles(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.deleteEquipmentFiles(action.payload);
        yield put(showSuccessSnackbar(data.message));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* watchAll() {
    yield takeEvery(actions.Types.DOWNLOAD_EXCEL_FILE, downloadExcelFile);
    yield takeEvery(actions.Types.GET_EQ_MAIN_LIST_BY_AREA, getEqGetMainListByAreaID);
    yield takeEvery(actions.Types.GET_AREA_FOR_EQ, getAreaList);
    yield takeEvery(actions.Types.GET_EQ_MAIN_LIST, getEqMainList);
    yield takeEvery(actions.Types.GET_PLANT_LIST, getPlantList);
    yield takeEvery(actions.Types.GET_EQ_TYPES, getEquipmentTypeList);
    yield takeEvery(actions.Types.GET_COST_CENTER_FOR_EQ, getCostCenterList);
    yield takeEvery(actions.Types.GET_EQUIPMENT_SUBLIST_BY_ID, getEqGetSubListById);
    yield takeEvery(actions.Types.GET_EQUIPMENT_BY_BAR_CODE, getEqGetByBarcodeContext);
    yield takeEvery(actions.Types.GET_EQ_DETAIL_LIST, getEqDetailList);
    yield takeEvery(actions.Types.DELETE_EQUIPMENT, deleteEquipment);
    yield takeEvery(actions.Types.GET_EQ_DETAIL_BY_ID, getEquipmentDetailById);
    yield takeEvery(actions.Types.GET_EQ_REPORT_GROUP_LIST, getEquipmentReportGroupList);
    yield takeEvery(actions.Types.GET_EQUIPMENT_REPORT_GROUP_BY_ID, getEquipmentReportGroupById);
    yield takeEvery(actions.Types.GET_EDIT_GROUP_INFO, editEquipmentGroupInfo);
    yield takeEvery(actions.Types.GET_EDIT_EQUIPMENT, getEditEquipment);
    yield takeEvery(actions.Types.GET_ADD_EQUIPMENT, getAddEquipment);
    yield takeEvery(actions.Types.GET_EQUIPMENT_FILES, getEquipmentFiles);
    yield takeEvery(actions.Types.ADD_EQUIPMENT_FILES, addEquipmentFiles);
    yield takeEvery(actions.Types.DELETE_EQUIPMENT_FILES, deleteEquipmentFiles);
}

const equipmentSaga = [fork(watchAll)];

export default equipmentSaga;
